import React, { useState } from 'react';
import { Grid, Menu, MenuItem, Button } from '@material-ui/core';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

function MenuButton({ title, options, selectOption }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelectOption = (value) => {
        selectOption(value);
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Grid xs={3} item container alignItems="center" justifyContent="center" onClick={handleClick}>
                <Button color="primary" endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}>
                    {title}
                </Button>
            </Grid>
            <Menu
                id="fade-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                {options.map((option, index) => (
                    <MenuItem key={index} onClick={() => handleSelectOption(option.value)}>
                        {option.label}
                    </MenuItem>
                ))}
            </Menu>
        </React.Fragment>
    );
}

export default MenuButton;
